import ngoProfileService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    loading: false,
    branches: [],
    working: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
    branches(state) {
      return state.branches;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setBranches(state, payload) {
      state.branches = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async getBranches({ commit }) {
      commit("setLoading", true);
      try {
        const res = await ngoProfileService.fetchBranches();
        commit("setBranches", res.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editBranch({ commit, dispatch }, payload) {
      commit("setWorking", true);
      const res = await ngoProfileService.updateBranch(payload);
      await dispatch("handleResponse", res);
      commit("setWorking", false);
    },
    async addBranch({ commit, dispatch }, payload) {
      commit("setWorking", true);
      const res = await ngoProfileService.addBranch(payload);
      await dispatch("handleResponse", res);
      commit("setWorking", false);
    },
    async deleteBranch({ commit, dispatch }, id) {
      commit("setLoading", true);
      const res = await ngoProfileService.deleteBranch(id);
      await dispatch("handleResponse", res);
    },
    handleResponse({ dispatch, commit }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",

            variant: "danger",
          },
        });
        commit("setWorking", false);
        commit("setLoading", false);
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",

            variant: "success",
          },
        });
        dispatch("getBranches");
      }
    },
  },
};
